export function getUser(state) {
  return state.user;
}

export function getBenefitsGroup(state) {
  return state.current_user.benefit_group.benefits.benefit_types;
}

export function getSelectedUser(state) {
  return state.selectedUser;
}

export function getCurrentUser(state) {
  return state.current_user;
}

export function parents(state) {
  let father = state.user.father
  let siblings = state.user.siblings
  let childrens = state.user.childrens
  return { father, siblings, childrens };
}
